module.exports = __webpack_public_path__ + "img/t-28431-147.f270fd94.jpg";